import { lazy, Suspense, type ReactNode } from "react";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { Layout } from "@/components/layout/Layout";
import { ModeratorLayout } from "@/components/moderator/ModeratorLayout";
import { useApp } from "@/hooks/use-app-context";
import { normalizeUserRole } from "@/lib/auth/roles";

const AccountantLayout = lazy(() => import("@/components/accountant/AccountantLayout"));

export function ContributionRouteLayout({ children }: { children: ReactNode }) {
  const { user, t } = useApp();

  switch (normalizeUserRole(user?.role)) {
    case "admin":
    case "super_admin":
      return <AdminLayout>{children}</AdminLayout>;
    case "moderator":
      return <ModeratorLayout>{children}</ModeratorLayout>;
    case "accountant":
      return (
        <Suspense fallback={<div role="status">{t.loading}</div>}>
          <AccountantLayout>{children}</AccountantLayout>
        </Suspense>
      );
    default:
      return <Layout>{children}</Layout>;
  }
}
